import React from 'react';

import { Checkbox, Group, Text } from '@mantine/core';
import useUpdateGoogleCalendarIntegration from 'hooks/googleCalendarIntegration/useUpdateGoogleCalendarIntegration';
import { GoogleCalendarIntegration } from 'types';
import notificationHandler from 'utils/notifications';

interface EventTypeCheckboxProps {
  googleCalendarIntegration: GoogleCalendarIntegration;
  type: 'syncAppointmentsToCalendar' | 'syncClassesToCalendar';
}

const EventTypeCheckbox = ({ googleCalendarIntegration, type }: EventTypeCheckboxProps): JSX.Element => {
  const { errorNotification } = notificationHandler();
  const updateGoogleCalendarIntegrationMutation = useUpdateGoogleCalendarIntegration();

  const value =
    type === 'syncAppointmentsToCalendar'
      ? googleCalendarIntegration.syncAppointmentsToCalendar
      : googleCalendarIntegration.syncClassesToCalendar;
  const label = type === 'syncAppointmentsToCalendar' ? 'Appointments' : 'Classes';

  const handleUpdate = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = event.currentTarget.checked;
    const updatePayload = {
      ...googleCalendarIntegration,
      [type]: isChecked,
    };

    updateGoogleCalendarIntegrationMutation.mutate(updatePayload, {
      onError: error => {
        errorNotification('Integration update failed', error.response?.data.message);
      },
    });
  };

  return (
    <Group>
      <Checkbox
        checked={value}
        onChange={handleUpdate}
        disabled={updateGoogleCalendarIntegrationMutation.isLoading}
      />
      <Text>{label}</Text>
    </Group>
  );
};

export default EventTypeCheckbox;
